import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-cell-editor',
  templateUrl: './cell-editor.component.html',
  styleUrls: ['./cell-editor.component.css'],
  standalone: false
})
export class CellEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public params: any;
  @ViewChild('inputField') public inputField: ElementRef;

  constructor() {}

  agInit(params: any): void {
    this.params = params;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.inputField.nativeElement.select();
    });
  }

  getValue(): any {
    // trigger blur event so number input directive can do its thing
    this.inputField.nativeElement.blur();
    return this.params.value;
  }
}
